<template>
    <div style="width:100%;text-align: center;">
        <v-container  class="content-background"   justify="center" fill-height fluid style="margin:0px;padding:0px;width:100%;text-align: center;">
            <v-form style="margin:0px;padding:0px;width:100%;text-align: center;" @submit.prevent="startRequestVariantList()">
                <v-row justify="center" style="text-align: center;margin:0;padding:0;">
                    <v-col cols="12" md="12" lg="12" xl="12" justify="center" style="text-align:center;">
                        <v-row align="center" justify="center">
                            <v-col cols="12" sm="8" md="8" lg="6" xl="6" justify="center" style="margin:0;padding:0;text-align:center;">
                                <div style="height:50px;"></div>
                                <SearchBar @clear-table="this.$store.dispatch('clearAGG')"></SearchBar>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row style="margin-top:0;padding-top:0;">
                    <v-col cols="12" md="12" lg="12" xl="12" justify="center">
                        <div id="upload-data-routing" style="margin:0;padding-right:0;">
                            <div style="" ref="loadingContainer"></div>
                            <v-row justify="center" align="center" style="margin-top:10px;">
                                <div id="results-loading" v-html="this.$store.getters.getProcessState('load-results')"></div>
                            </v-row>
                            <v-container fluid style="margin:0;padding:20px;">

                                    <v-row>
                                        <v-col cols="12" md="12" lg="12" xl="12">
                                            <div v-if="hg38_converted" style="margin:0px;">
                                                <span style="border:1px solid #a6cb92;background-color: #e1fcd3; padding:10px;">
                                                Your data was converted to hg38 / GRCh38.

                                                <span
                                                                                style="margin-left:10px; margin-right:10px;">
                                                                                <v-icon
                                                                                  color="black" icon="mdi-tooltip-question-outline"
                                                                                  text="Variant data converted to hg38"
                                                                                  @click="dialog_converthint = true"
                                                                                ></v-icon>
                                                                            </span>

                                                                            <v-dialog
                                                                              v-model="dialog_converthint"
                                                                              max-width="1200"
                                                                              height="600"
                                                                              persistent
                                                                            >
                                                                                <v-list
                                                                                class="py-2"
                                                                                color="primary"
                                                                                elevation="4"
                                                                                rounded="lg"
                                                                              >
                                                                                <v-list-item
                                                                                  prepend-icon="mdi-help"
                                                                                  title=""
                                                                                >
                                                                                  <template v-slot:prepend>
                                                                                    <div class="pe-4">
                                                                                        <div>

                                                                                            Onkopus works internally in hg38(GRCh38).
                                                                                            To process data in hg19, your data was converted to hg38.
                                                                                            <br />
                                                                                        </div>
                                                                                    </div>
                                                                                  </template>

                                                                                  <template v-slot:append>
                                                                                      <div>
                                                                                      <v-btn
                                                                                        class="ms-auto"
                                                                                        text="Ok"
                                                                                        @click="dialog_converthint = false"
                                                                                      ></v-btn>
                                                                                      </div>
                                                                                    </template>

                                                                                </v-list-item>
                                                                              </v-list>
                                                                            </v-dialog>

                                                </span>
                                            </div>
                                            <div style="">
                                                <router-view :key="$route.fullPath"></router-view>
                                            </div>
                                        </v-col>
                                     </v-row>
                            </v-container>
                        </div>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
        <div style="width:100%;height:50px;"></div>
        <Loading v-model:active="isLoading" v-model="fullPage"
       :can-cancel="true"
       :on-cancel="onCancel"
       :is-full-page="fullPage" />
    </div>
</template>
<script>
import 'vue-loading-overlay/dist/css/index.css';
import { ref } from "@vue/reactivity";
import { h } from 'vue';

// Components
import SearchBar from '@/components/query_components/SearchBar.vue';
import variant_annotation from "@/methods/variant_annotation";
import { useDisplay } from 'vuetify'

export default {
  name: 'upload-files',
  components: {
    SearchBar,
  },
  setup() {
    const items = ref([]);

    function logger(evt) {
      console.log(evt);
    }

    const { name } = useDisplay()
    //console.log(name.value)
    const popup_open = ref(false);

    return {
      logger,
      items,
      fileRecords: [],
      uploadUrl: "",
      popup_open,
    };
  },
  props: {
    server_path: String,
    methods_get_variant_search: String,
    methods_upload_vcf: String
  },
  data: function() {
    return {
      uploaddatarv:0,
      flask_greeting: '',
      message: '',
      isLoading: false,
      fullPage: false,
      uploadData: 'testdata',
      appTitle: 'Onkopus Web App',
      sidebar: false,
      menuItems: [
        { title: 'Home', path: '/home', icon: 'home' },
        { title: 'Sign Up', path: '/signup', icon: 'face' },
        { title: 'Sign In', path: '/signin', icon: 'lock_open' }
      ],
      grid: undefined,
      componentKey: 0,
      msg: 'test',
      interval: {},
      value: 0,
      hg38_converted: false,
      dialog_converthint: false,
    }
  },
  render() {
    return h('div', this.msg)
  },
  mounted() {
    //this.onResize()
      if (!localStorage.getItem("onkopus_consent")) this.popup_open = true;

      //window.addEventListener('resize', this.onResize, { passive: true })

    this.uploadUrl = this.server_path + this.methods_upload_vcf
    this.id = this.$route.query.id
    if (this.id != null) {
      this.$store.dispatch('setIdData',this.id)
    }

    this.interval = setInterval(() => {
        if (this.value === 100) {
          return (this.value = 0)
        }
        this.value += 10
      }, 1000)


    // display tooltip if user data has been converted to hg38
    if ((this.$store.getters.getGenomeVersion != "") && (this.$store.getters.getGenomeVersion != "hg38")) {
        this.hg38_converted = true
    }

  },
  methods: {
        onResize () {
        this.isMobile = window.innerWidth < 600
      },
    forceRerender() {
      this.componentKey += 1
    },
    inputUpperCase(event) {
      this.$emit("upperCase", event.target.value.toUpperCase())
    },
    async updateDataRV() {
      this.uploaddatarv += 1
    },
    perc2color(perc,min,max) {
            var base = (max - min);

            if (base == 0) { perc = 100; }
            else {
                perc = (perc - min) / base * 100; 
            }
            var r, g, b = 0;
            if (perc < 50) {
                g = 255;
                r = Math.round(5.1 * perc);
            }
            else {
                r = 255;
                g = Math.round(510 - 5.10 * perc);
            }
            var h = r * 0x10000 + g * 0x100 + b * 0x1;
            return '#' + ('000000' + h.toString(16)).slice(-6);
        },
    async startRequestVariantList() {
      await variant_annotation.getVariants("sample")
      this.uploaddatarv += 1;
    },
    doAjax() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false
      }, 20000)
    },
    onCancel() {
      console.log('User cancelled the loader')
    },
    submit() {
                let loader = this.$loading.show({
                    // Optional parameters
                    container: this.fullPage ? null : this.$refs.loadingContainer,
                    canCancel: true,
                    onCancel: this.onCancel,
                });
                // simulate AJAX
                setTimeout(() => {
                    loader.hide()
                }, 5000)
    },
    loaded() {
        this.isLoaded = true;
      this.isLoading = false;
    },
    toggleimg: function(){
        if (this.imgsrc == "") {
      this.isLoaded =  false;
      this.isLoading = true;
        this.btntext = "Hide Image"
      }else{
      this.imgsrc = ""
      this.btntext = "Show Image"
      }
    },
  },
  beforeUnmount () {
    clearInterval(this.interval)
  },
  created: async function() {
    this.mobile = useDisplay()
  }
}
</script>
<style scoped>

v-btn {
  margin:0px;
}
.input-form-light {
  background-color:#FFFFFF;
}
.v-progress-circular {
  margin: 1rem;
}
.loading {
  background: transparent url('https://miro.medium.com/max/882/1*9EBHIOzhE1XfMYoKz1JcsQ.gif') center no-repeat;
  height: 400px;
  width: 400px;
}
.content-background {
    /*background-color: #ffffff;*/
    opacity: 1.0;
}
</style>
